import { render, staticRenderFns } from "./BusinessEntityEdit.vue?vue&type=template&id=52473798&"
import script from "./BusinessEntityEdit.vue?vue&type=script&lang=js&"
export * from "./BusinessEntityEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports